import {H1} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {ShutdownHistoryCard} from './ShutdownHistoryCard'
import {StaticPartDetailCard} from './StaticPartDetailCard'

export const StaticPartDetail = () => {
  const {t} = useTranslation()

  return (
    <div>
      <div className="flex justify-between items-center">
        <H1 className="my-6 ml-6 max-w-400px">{t('staticParts.detail')}</H1>
      </div>
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-1">
          <ShutdownHistoryCard />
        </div>
        <div className="col-span-2">
          <StaticPartDetailCard />
        </div>
      </div>
    </div>
  )
}
